import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LOADER_POLICY } from '@shared/constants/http-loader.constants';
import { LoaderService } from '@shared/services/loader/loader.service';
import { finalize } from 'rxjs';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const policy = req.context.get(LOADER_POLICY);
  const routeSuppressed = loaderService.suppressGlobalLoader;

  if (loaderService.isDisabled) {
    return next(req);
  }

  if (policy === 'suppress') {
    return next(req);
  }

  if (policy === 'default' && routeSuppressed) {
    return next(req);
  }

  const useBlockingLoader = policy === 'force' && routeSuppressed;
  const trackRequest = !routeSuppressed || useBlockingLoader;

  if (useBlockingLoader) {
    loaderService.beginBlockingLoader();
  }

  if (trackRequest) {
    loaderService.totalRequests++;
    if (!loaderService.isDisabled) {
      loaderService.setLoading(true, useBlockingLoader ? { force: true } : undefined);
    }
  }

  return next(req).pipe(
    finalize(() => {
      if (trackRequest) {
        loaderService.totalRequests--;
        if (loaderService.totalRequests === 0 && !loaderService.isDisabled) {
          loaderService.setLoading(false);
        }
      }
      if (useBlockingLoader) {
        loaderService.endBlockingLoader();
      }
    })
  );
};
